import React, {
    useEffect,
    useState,
} from "react";

import AdminLayout from "./AdminLayout";

const AdminAlumniComments = () => {

    const [
        comments,
        setComments,
    ] = useState([]);

    useEffect(() => {

        fetchComments();

    }, []);

    const fetchComments =
        async () => {

            const res =
                await fetch(
                    "https://stjosephweb.ilakshyaerp.in/api/alumni-comment/all"
                );

            const result =
                await res.json();

            if (
                result.success
            ) {

                setComments(
                    result.comments
                );

            }
        };

    // APPROVE
    const approveComment =
        async (id) => {

            await fetch(
                `https://stjosephweb.ilakshyaerp.in/api/alumni-comment/approve/${id}`,
                {
                    method:
                        "PUT",
                }
            );

            fetchComments();
        };

    // REJECT
    const rejectComment =
        async (id) => {

            await fetch(
                `https://stjosephweb.ilakshyaerp.in/api/alumni-comment/reject/${id}`,
                {
                    method:
                        "PUT",
                }
            );

            fetchComments();
        };

    // DELETE
    const deleteComment =
        async (id) => {

            await fetch(
                `https://stjosephweb.ilakshyaerp.in/api/alumni-comment/delete/${id}`,
                {
                    method:
                        "PUT",
                }
            );

            fetchComments();
        };

    return (

        <AdminLayout>

            <div className="notice-page">

                <div className="flex justify-between items-center mb-8 flex-wrap gap-4">

                    {/* LEFT */}
                    <div>

                        <h2 className="text-3xl font-bold text-[#072F5F]">

                            Alumni Comment Management

                        </h2>

                        <p className="text-gray-500 mt-1">

                            Manage approved and pending alumni comments

                        </p>

                    </div>

                    {/* RIGHT BUTTONS */}
                    <div className="flex gap-4 flex-wrap">

                        {/* BACK BUTTON */}
                        <button
                            onClick={() =>
                                window.location.href =
                                "/admin/alumni"
                            }
                            className="
            bg-white
            border-2
            border-[#072F5F]
            text-[#072F5F]
            hover:bg-[#072F5F]
            hover:text-white
            font-semibold
            px-6
            py-3
            rounded-2xl
            shadow-md
            transition-all
            duration-300
            flex
            items-center
            gap-2
          "
                        >

                            <span>

                                ←

                            </span>

                            Back

                        </button>

                        {/* COMMENT BUTTON */}
                        <button
                            className="
            bg-gradient-to-r
            from-[#072F5F]
            to-[#0d4b97]
            text-white
            font-semibold
            px-7
            py-3
            rounded-2xl
            shadow-lg
            flex
            items-center
            gap-3
          "
                        >

                            <span className="text-xl">

                                💬

                            </span>

                            Total Comments :
                            {" "}

                            {
                                comments.length
                            }

                        </button>

                    </div>

                </div>

                <div className="notice-table overflow-x-auto">

                    <h2>
                        All Comments
                    </h2>

                    <table>

                        <thead>

                            <tr>

                                <th>
                                    Image
                                </th>

                                <th>
                                    Name
                                </th>

                                <th>
                                    Comment
                                </th>

                                <th>
                                    Status
                                </th>

                                <th>
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                comments.map(
                                    (
                                        item
                                    ) => (

                                        <tr
                                            key={
                                                item.id
                                            }
                                        >

                                            <td>

                                                <img
                                                    src={`https://stjosephweb.ilakshyaerp.in/uploads/alumni/${item.image}`}
                                                    alt=""
                                                    width="70"
                                                    height="70"
                                                    style={{
                                                        borderRadius:
                                                            "50%",
                                                        objectFit:
                                                            "cover",
                                                    }}
                                                />

                                            </td>

                                            <td>

                                                {
                                                    item.fullName
                                                }

                                            </td>

                                            <td>

                                                {
                                                    item.commentText
                                                }

                                            </td>

                                            <td>

                                                {
                                                    item.status
                                                }

                                            </td>

                                            <td>

                                                <div className="flex gap-2">

                                                    <button
                                                        onClick={() =>
                                                            approveComment(
                                                                item.id
                                                            )
                                                        }
                                                        className="
                                                        bg-green-600
                                                        text-white
                                                        px-4
                                                        py-2
                                                        rounded-lg
                                                      "
                                                    >
                                                        Approve
                                                    </button>

                                                    <button
                                                        onClick={() =>
                                                            rejectComment(
                                                                item.id
                                                            )
                                                        }
                                                        className="
                                                        bg-yellow-500
                                                        text-white
                                                        px-4
                                                        py-2
                                                        rounded-lg
                                                      "
                                                    >
                                                        Reject
                                                    </button>

                                                    <button
                                                        onClick={() =>
                                                            deleteComment(
                                                                item.id
                                                            )
                                                        }
                                                        className="
                                                        bg-red-600
                                                        text-white
                                                        px-4
                                                        py-2
                                                        rounded-lg
                                                      "
                                                    >
                                                        Delete
                                                    </button>

                                                </div>

                                            </td>

                                        </tr>
                                    )
                                )
                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>
    );
};

export default AdminAlumniComments;